"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return;
}